// @flow

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { ownerFragment, searchMasterFragment } from 'common/fragments/www'
import { viewerFragment, historyRoomsFragment } from 'common/fragments'
import { convertToSearchSessionIdParams } from 'helpers/search'
import { parseRoomIdParam } from 'helpers/room'

const roomGQL = gql`
  query room(
    $id: Int,
    $uid: String,
    $searchSessionId: String,
  ) {
    ${searchMasterFragment}
    room(id: $id, uid: $uid, rentType: DAY_TIME, searchSessionId: $searchSessionId) {
      id
      uid
      breadcrumbs {
        title
        path
      }
      name
      capacity
      description
      reservableStart
      equipmentDescription
      isFavorite
      favoritesCount
      allowRentTypes
      roomDisplayType
      roomSettingStatus
      amenities {
        results {
          name
        }
      }
      eventTypes{
        results{
          name
           nameText 
        }
      }
      plans(page: 1) {
        results {
          id
          name
          description
          directReservationAccepted
          isLastMinuteDiscount
          lastMinuteDiscountPercentage
          minRequiredHour
          hourlyPriceText
          minHourlyPrice
          hourlyPriceUnitText
          dailyPriceText
          dailyPriceUnitText
          optionCleaningPrice
          optionCleaningPriceText
        }
      }
      prices(limit: 20) {
        minText
        minUnitText
        maxText
        maxUnitText
      }
      attachFiles(page: 1) {
        results {
          description
          url
        }
      }
      hasDirectReservationPlans
      hasLastMinuteDiscountPlans
      area
      foodDescription
      trashDescription
      embedVideoUrl
      embedVrUrl
      thumbnails(page: 1, perPage: 30) {
        results {
          url
          description
        }
      }
      attachFiles(page: 1) {
        results {
          url
          description
        }
      }
      relatedEntries(page: 1) {
        results {
          title
          url
          image
          description
        }
      }
      reputations(page: 1) {
        results {
          description
          replyReputation
          from {
            ... on User {
              name
              profileImage
              username
            }
          }
          reservation {
            startedAt
            eventTypeText
            eventType
          }
        }
      }
      optionItems(page: 1) {
        results {
          name
          priceText
          priceUnitText
          description
          thumbnails {
            results {
              id
              description
              url
            }
          }
        }
      }
      terms
      policy
      space {
        name
        username
        state
        stateText
        city
        address1
        address2
        description
        latitude
        longitude
        access
        spaceType
        spaceTypeText
      }
      owner {
        ${ownerFragment}
      }
      reputationSummary {
        score
        count
      }
      usageRates {
        eventTypeText
        rate
      }
      usedGuestsCount(days: 7)
      sponsoredPromotions(page: 1) {
        results {
          id
          name
          brandName
          sponsorName
          link
        }
      }
    }
    banners {
      results {
        id
        title
        subtitle
        externalUrl
        startedAt
        isLimited
        searchQuery
        endedAt
        backgroundColor
      }
    }
    viewer {
      ${viewerFragment}
      ${historyRoomsFragment}
    }
  }
`

function parseRoomIdOwnParam(ownRoomId) {
  if (/^[0-9]+$/.test(ownRoomId)) {
    return !parseInt(ownRoomId, 10)
  }
  return !ownRoomId
}

export default function(component: any) {
  return graphql(roomGQL, {
    options: props => ({
      variables: Object.assign(
        parseRoomIdParam(props.match.params.roomId),
        convertToSearchSessionIdParams(props.location.search),
      ),
    }),
    skip: ownProps => parseRoomIdOwnParam(ownProps.match.params.roomId),
  })(component)
}



// WEBPACK FOOTER //
// ./src/containers/pages/RoomPage/graphql.js